import { IconProps } from "@design-system/types";

export function FooterLogoIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="321"
      height="134"
      viewBox="0 0 321 134"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_138_388)">
        <mask
          id="mask0_138_388"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="321"
          height="134"
        >
          <path d="M321 0H0V134H321V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_138_388)">
          <path
            d="M171.246 83.5156H161.091V133.715H171.246V83.5156Z"
            fill="white"
          />
          <path
            d="M121.468 83.5156V133.722H131.623V100.889L155.914 127.897V110.226L131.623 83.5156H121.468Z"
            fill="white"
          />
          <path
            d="M75.8926 83.5156V133.722H115.614V123.577H86.0537V93.6602H115.614V83.5156H75.8926Z"
            fill="white"
          />
          <path
            d="M112.807 103.308H91.1978V113.446H112.807V103.308Z"
            fill="white"
          />
          <path
            d="M255.72 93.5608L264.872 112.134H246.667L255.72 93.5608ZM249.083 83.5156L232.716 121.172L237.84 133.715L242.546 122.166H268.867L273.52 133.715H284.385L262.562 83.5156H249.083Z"
            fill="white"
          />
          <path
            d="M274.13 83.5156V93.6602H289.919V133.722H299.981V93.6602H310.54L321 83.5156H274.13Z"
            fill="white"
          />
          <path
            d="M196.26 83.5156L174.438 133.722H185.096L189.722 122.172H210.35L206.414 112.134H193.844L202.996 93.5608L220.697 133.722H231.555L210.038 84.324L209.733 83.5156H196.26Z"
            fill="white"
          />
          <path
            d="M11.3358 104.01C9.95534 102.744 9.16555 100.969 9.16555 99.0073C9.16555 95.2371 12.2384 92.1692 16.0148 92.1692H27.928L28.0741 92.0698L40.7505 83.0251H16.0082C7.18112 83.0251 0 90.1946 0 99.0073C0 102.89 1.39375 106.535 3.82285 109.377L11.3358 104.017V104.01Z"
            fill="white"
          />
          <path
            d="M56.5992 83.0251C52.6901 83.0251 48.8805 84.2311 45.6882 86.4773L37.2262 92.4342L8.3623 113.041C8.45522 113.094 8.54814 113.147 8.64105 113.2C10.9706 114.406 13.4993 115.003 16.0146 115.003C19.2534 115.003 22.4723 114.016 25.2333 112.074L66.5214 83.0251H56.5926H56.5992Z"
            fill="white"
          />
          <path
            d="M58.9489 113.009C60.3294 114.274 61.1192 116.05 61.1192 118.011C61.1192 121.782 58.0463 124.849 54.2699 124.849H42.3567L42.2106 124.949L29.5342 133.993H54.2632C63.0903 133.993 70.2714 126.824 70.2714 118.011C70.2714 114.128 68.8777 110.484 66.4486 107.641L58.9356 113.002L58.9489 113.009Z"
            fill="white"
          />
          <path
            d="M13.6851 134C17.5943 134 21.4038 132.794 24.5962 130.541L33.0582 124.584L61.9221 103.977C61.8292 103.924 61.7362 103.871 61.6433 103.818C59.3138 102.612 56.7851 102.016 54.2697 102.016C51.0309 102.016 47.812 103.003 45.0511 104.944L3.75635 134H13.6851Z"
            fill="white"
          />
          <path
            d="M283.94 31.1428L288.765 27.7502C288.712 27.79 288.652 27.8165 288.599 27.8563L283.933 31.1362L283.94 31.1428Z"
            fill="white"
          />
          <path
            d="M210.344 22.7209H199.028V63.2595H210.344V22.7209Z"
            fill="white"
          />
          <path
            d="M190.731 2.16675H179.415V63.2529H190.731V2.16675Z"
            fill="white"
          />
          <path
            d="M87.5212 51.9554H11.8009L0.146484 63.2596H87.5212H89.9105H98.8371V23.0391H87.5212V51.9554Z"
            fill="white"
          />
          <path
            d="M204.681 -0.00423028L196.455 8.20923L204.681 16.4227L212.908 8.20923L204.681 -0.00423028Z"
            fill="white"
          />
          <path
            d="M68.1946 17.4455L59.9678 25.6589L68.1946 33.8724L76.4214 25.6589L68.1946 17.4455Z"
            fill="white"
          />
          <path
            d="M59.9714 25.6629L51.7483 17.4465L43.5186 25.6629L51.7483 33.8727L59.9714 25.6629Z"
            fill="white"
          />
          <path
            d="M139.222 41.6319C139.222 35.9401 143.861 31.3084 149.562 31.3084C152.556 31.3084 155.396 32.6005 157.367 34.86L165.902 27.4454C161.787 22.721 155.828 20.0175 149.562 20.0175C137.623 20.0175 127.906 29.7182 127.906 41.6385C127.906 45.3757 128.862 48.8941 130.534 51.962H118.442V2.16675H107.126V63.2529H171.119V51.9554H149.556C143.855 51.9554 139.215 47.3237 139.215 41.6319"
            fill="white"
          />
          <path
            d="M312.193 20.0042L302.344 26.9218C302.344 26.9218 302.357 26.9218 302.364 26.9284C306.85 29.2542 309.532 33.654 309.532 38.6964C309.532 46.005 303.572 51.9553 296.251 51.9553H266.75L250.702 63.2528H296.251C309.817 63.2528 320.847 52.2336 320.847 38.6964C320.847 31.3746 317.622 24.6027 312.193 20.0042Z"
            fill="white"
          />
          <path
            d="M288.599 27.8627C288.652 27.8229 288.711 27.7898 288.765 27.7567L305.543 15.9754C297.804 12.8148 289.004 13.7557 282.081 18.6325L239.439 48.6555L228.123 56.5869L218.639 63.2594H228.522C234.833 63.2594 240.992 61.3114 246.149 57.6869L283.94 31.1493L288.605 27.8693L288.599 27.8627Z"
            fill="white"
          />
          <path
            d="M229.955 22.7209H218.639V54.5661L229.955 46.5949V22.7209Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_138_388">
          <rect width="321" height="134" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
